import React from 'react';
import PropTypes from 'prop-types';
import ListWithDetails from 'components/Common/ListWithDetails';
import ImmunizationDetails from 'components/HealthRecords/Immunizations/ImmunizationDetails';
import ImmunizationBadge from 'components/HealthRecords/Immunizations/ImmunizationBadge';
import PerformanceUtils from 'services/PerformanceUtils';

const ImmunizationsList = props => (
  <ListWithDetails
    patient={props.patient}
    items={PerformanceUtils.sortBy(props.immunizations)}
    title={props.title}
    renderBadge={item => <Badge item={item} renderBadge={props.renderBadge} />}
    renderDetails={item => (
      <Details item={item} renderDetails={props.renderDetails} />
    )}
  />
);

const Badge = ({ item, renderBadge }) =>
  renderBadge ? renderBadge(item) : <ImmunizationBadge item={item} />;

const Details = ({ item, renderDetails }) =>
  renderDetails ? (
    renderDetails(item)
  ) : (
    <ImmunizationDetails
      key={item.id}
      immunization={item}
      inputDisabled={true}
    />
  );

ImmunizationsList.propTypes = {
  patient: PropTypes.object.isRequired,
  immunizations: PropTypes.array.isRequired,
  renderBadge: PropTypes.func,
  renderDetails: PropTypes.func
};

export default ImmunizationsList;
